import { getProductVariants } from './productVariants';
import { cleanProductData } from './productSnapshotPersistence';
// Firestore maps do not promise insertion order. Sort map keys recursively while
// preserving array positions, scalar types, and all actual field values.
const canonicalValue = value => {
  if (Array.isArray(value)) return value.map(canonicalValue);
  if (value && value.constructor === Object) return Object.fromEntries(Object.keys(value).sort().map(key => [key, canonicalValue(value[key])]));
  return value;
};
export const sameValue = (a, b) => JSON.stringify(canonicalValue(a ?? null)) === JSON.stringify(canonicalValue(b ?? null));
export const VARIANT_FIELDS = ['styles', 'styleIds', 'styleBarcodes', 'rawStyleBarcodes', 'styleDetails'];
const RESERVED = new Set(['id', 'revision', 'createdAt', 'createdBy', 'updatedAt', 'updatedBy', 'history']);
export const cleanProductPatch = (patch) => cleanProductData(Object.fromEntries(Object.entries(patch).filter(([key, value]) => !RESERVED.has(key) && value !== undefined)));
export const findPatchConflicts = (base = {}, current = {}, patch = {}) => {
  const checked = Object.keys(patch);
  if (checked.some(key => VARIANT_FIELDS.includes(key))) checked.push(...VARIANT_FIELDS);
  const value = (record, key) => key === 'styleIds' && record[key] === undefined ? getProductVariants(record).map(v => v.id) : record[key];
  return [...new Set(checked)].filter(key => !sameValue(value(current, key), value(base, key)) && !sameValue(value(current, key), patch[key]));
};
export const estimateDocumentBytes = (value) => new TextEncoder().encode(JSON.stringify(value)).length;
export const assertProductSize = (product) => {
  // Keep headroom below Firestore's 1 MiB limit, including existing inline album photos.
  if (estimateDocumentBytes(product) > 850000) throw new Error('商品資料或舊圖片過大，請先縮減圖片後重試；目前輸入仍保留。');
};
